import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Form,
  Input,
  Button,
  Toast,
  NoticeBar,
} from 'antd-mobile';
import {
  FrownOutline
} from 'antd-mobile-icons';
import api from "../../api";

const Login = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [error, setError] = useState('');

  const onSubmit = () => {
    const values = form.getFieldsValue()

    api.login(values).then(res => {
      if (res.data.code === 0) {
        Toast.show({ content: '登陆成功', duration: 500, position: 'top' })
        navigate("/home")
      } else {
        setError(res.data.message)
        setTimeout(() => {
          setError('')
        }, 2000);
      }
    })
  }

  return (
    <div>
      {error ?
        <NoticeBar
          icon={<FrownOutline />}
          content={error}
          color='error'
        /> : undefined
      }

      <Form
        form={form}
        layout='horizontal'
        footer={
          <Button block color='primary' size='large' onClick={onSubmit}>
            提交
          </Button>
        }
      >
        <Form.Header>管理员登陆</Form.Header>
        <Form.Item
          name='username'
          label='用户名'
          rules={[{ required: true, message: '用户名不能为空' }]}
        >
          <Input placeholder='请输入用户名' clearable={true} />
        </Form.Item>
        <Form.Item
          name='password'
          label='密码'
          rules={[{ required: true, message: '密码不能为空' }]}
        >
          <Input type='password' placeholder='请输入密码' clearable={true} />
        </Form.Item>
      </Form>
    </div>
  )
}

export default Login;